module.exports = __webpack_public_path__ + "49aa356bf7d1a9126db366d799b9f1b5.pdf";